export const CONTACTS = {
    phoneDigits: '+8613323291767',
    phoneDisplay: '+8613323291767',
    email: 'info@meatasia.club',
};
